import React from 'react';
import { useFlashMessages } from '../../hooks/flashmessage';
import { makeStyles } from '@material-ui/core';
import FlashMessage from './FlashMessage';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
}));

export interface FlashMessageContainerProps {
    /**
     * An additional class-name added to the container
     */
    className?: string;
    /**
     * Force the container to render even when no messages exist
     */
    renderEmpty?: boolean;
}

export const FlashMessageContainer: React.FunctionComponent<FlashMessageContainerProps> = (props) => {
    const { messages, removeMessage } = useFlashMessages();
    const classes = useStyles({});

    if (!props.renderEmpty && messages.length === 0) {
        return null;
    }

    return (
        <div className={clsx(classes.root, props.className)}>
            {messages.map((message) => (
                <FlashMessage
                    key={message.id}
                    variant={message.variant}
                    message={message.message}
                    onClose={() => {
                        removeMessage(message.id);
                        if (message.onClose)
                            message.onClose();
                    }}
                    className={classes.marginBottom}
                />
            ))}
        </div>
    );
};
